import cx from 'classnames';

import { CompRiskLevel } from '@/api';
import { AlertType } from '@/models';
import { AlertBadge } from '@/components/AlertBadge';

import styles from './OptionAlert.module.sass';

export type OptionAlertType = {
  isSelected?: boolean;
  value: AlertType | CompRiskLevel;
};

const OptionAlert = ({ isSelected, value }: OptionAlertType) => {
  const classes = cx(styles.option, {
    [styles['is-selected']]: isSelected,
  });

  return <AlertBadge type={value} className={classes} />;
};

export default OptionAlert;
